// extracted by mini-css-extract-plugin
export default {"radius":"CompanyLocalization_radius__oEWTJ"};